<template>
  <div class="renewals">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "RenewalComponent",
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.document.title = "KISEB::Renewals";
    });
  },
};
</script>
